var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "공정 상세" } },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    disabled: true,
                    label: "공정명",
                    name: "processName",
                  },
                  model: {
                    value: _vm.popupParam.process.processName,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "processName", $$v)
                    },
                    expression: "popupParam.process.processName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    disabled: true,
                    label: "팀명(반)",
                    name: "assessDeptName",
                  },
                  model: {
                    value: _vm.popupParam.process.assessDeptName,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "assessDeptName", $$v)
                    },
                    expression: "popupParam.process.assessDeptName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    disabled: true,
                    label: "원(재)료",
                    name: "mainMaterial",
                  },
                  model: {
                    value: _vm.popupParam.process.mainMaterial,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "mainMaterial", $$v)
                    },
                    expression: "popupParam.process.mainMaterial",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    disabled: true,
                    type: "number",
                    label: "근로자수(명)",
                    name: "workerCnt",
                  },
                  model: {
                    value: _vm.popupParam.process.workerCnt,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "workerCnt", $$v)
                    },
                    expression: "popupParam.process.workerCnt",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    editable: false,
                    disabled: true,
                    label: "생산품(기종)",
                    name: "productName",
                  },
                  model: {
                    value: _vm.popupParam.process.productName,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "productName", $$v)
                    },
                    expression: "popupParam.process.productName",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: { title: "기타 안전보건상 정보" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-accident", {
                  attrs: {
                    editable: _vm.editable,
                    multiple: "",
                    disabled: true,
                    label: "최근 3년간 재해발생사례",
                    name: "accidentHistoryDesc",
                  },
                  model: {
                    value: _vm.popupParam.process.accidentHistoryDesc,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.popupParam.process,
                        "accidentHistoryDesc",
                        $$v
                      )
                    },
                    expression: "popupParam.process.accidentHistoryDesc",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-accident", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    isNear: true,
                    multiple: "",
                    label: "아차사고사례",
                    name: "nearMissDesc",
                  },
                  model: {
                    value: _vm.popupParam.process.nearMissDesc,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "nearMissDesc", $$v)
                    },
                    expression: "popupParam.process.nearMissDesc",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    codeGroupCd: "MDM_PROCESS_WORKER_TYPE_CD",
                    disabled: true,
                    isArray: false,
                    label: "근로자 구성 및 경력특성",
                    name: "workerTypeCd",
                    itemText: "codeName",
                    itemValue: "code",
                  },
                  model: {
                    value: _vm.popupParam.process.workerTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "workerTypeCd", $$v)
                    },
                    expression: "popupParam.process.workerTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    codeGroupCd: "MDM_PROCESS_TRANSPORT_TYPE_CD",
                    type: "edit",
                    disabled: true,
                    isArray: false,
                    itemText: "codeName",
                    itemValue: "code",
                    name: "heavyTransportTypeCd",
                    label: "중량물 운반수단",
                  },
                  model: {
                    value: _vm.popupParam.process.heavyTransportTypeCd,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.popupParam.process,
                        "heavyTransportTypeCd",
                        $$v
                      )
                    },
                    expression: "popupParam.process.heavyTransportTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "장비명",
                    name: "heavyTransportEquip",
                  },
                  model: {
                    value: _vm.popupParam.process.heavyTransportEquip,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.popupParam.process,
                        "heavyTransportEquip",
                        $$v
                      )
                    },
                    expression: "popupParam.process.heavyTransportEquip",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    isFlag: true,
                    label: "교대작업 유무",
                    name: "shiftFlag",
                  },
                  model: {
                    value: _vm.popupParam.process.shiftFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "shiftFlag", $$v)
                    },
                    expression: "popupParam.process.shiftFlag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    isFlag: true,
                    label: "중량물 인력취급유무",
                    name: "heavyManualFlag",
                  },
                  model: {
                    value: _vm.popupParam.process.heavyManualFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "heavyManualFlag", $$v)
                    },
                    expression: "popupParam.process.heavyManualFlag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    codeGroupCd: "MDM_PROCESS_HANDLING_TYPE_CD",
                    type: "edit",
                    itemText: "codeName",
                    disabled: true,
                    isArray: false,
                    itemValue: "code",
                    name: "heavyManualTypeCd",
                    label: "취급형태(들기/밀기/끌기)",
                  },
                  model: {
                    value: _vm.popupParam.process.heavyManualTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "heavyManualTypeCd", $$v)
                    },
                    expression: "popupParam.process.heavyManualTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    isFlag: true,
                    label: "작업환경측정 실시",
                    name: "workEnvMeasureFlag",
                  },
                  model: {
                    value: _vm.popupParam.process.workEnvMeasureFlag,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.popupParam.process,
                        "workEnvMeasureFlag",
                        $$v
                      )
                    },
                    expression: "popupParam.process.workEnvMeasureFlag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "노출초과인자/수치",
                    name: "exposureOverValue",
                  },
                  model: {
                    value: _vm.popupParam.process.exposureOverValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam.process, "exposureOverValue", $$v)
                    },
                    expression: "popupParam.process.exposureOverValue",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("c-checkbox", {
                  attrs: {
                    editable: _vm.editable,
                    codeGroupCd: "RAM_RISK_PROCESS_SPECIAL_EDU_TARGET_CD",
                    type: "edit",
                    disabled: true,
                    isArray: false,
                    itemText: "codeName",
                    itemValue: "code",
                    name: "specialEduTargetCd",
                    label: "특별안전보건교육 해당",
                  },
                  model: {
                    value: _vm.popupParam.process.specialEduTargetCd,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.popupParam.process,
                        "specialEduTargetCd",
                        $$v
                      )
                    },
                    expression: "popupParam.process.specialEduTargetCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-table", {
        ref: "table",
        staticClass: "q-mt-sm q-mb-xl q-pb-xl",
        attrs: {
          title: "공정별 작업 시나리오",
          merge: _vm.grid.merge,
          columns: _vm.grid.columns,
          data: _vm.popupParam.process.fmScenarios,
          editable: _vm.editable && !_vm.popupParam.disabled,
          gridHeightAuto: "",
          isTitle: true,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          hideBottom: true,
        },
        scopedSlots: _vm._u([
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "customCol"
                  ? [
                      _c(_vm.imprComponent, {
                        tag: "component",
                        attrs: {
                          col: col,
                          props: props,
                          inputEditable:
                            _vm.editable && !_vm.popupParam.disabled,
                          isImmShow: true,
                          requestContentsCols: _vm.requestContentsCols,
                          tableKey: "ram4mAssessScenarioId",
                          ibmTaskTypeCd: "ITT0000023",
                          ibmTaskUnderTypeCd: "ITTU000030",
                        },
                        on: { imprChange: _vm.imprChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "customArea",
                              fn: function ({ props }) {
                                return [
                                  _c(
                                    "c-card",
                                    {
                                      staticClass: "cardClassDetailForm",
                                      attrs: { title: "시나리오 정보" },
                                    },
                                    [
                                      _c("template", { slot: "card-detail" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 row",
                                            staticStyle: {
                                              "margin-top": "-32px !important",
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.customReadOnlyCols,
                                              function (item, idx) {
                                                return [
                                                  _vm.isGroupStart(idx)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: "group-" + idx,
                                                          staticClass:
                                                            "col-12 scenario-group-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.group ===
                                                                  "A"
                                                                  ? "개선 전"
                                                                  : "개선 후"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: idx,
                                                      class: item.colClass,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mini-dailog-title",
                                                        },
                                                        [
                                                          _c("q-icon", {
                                                            attrs: {
                                                              name: "keyboard_arrow_right",
                                                              size: "xs",
                                                              color: "grey-8",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            _vm._s(item.label) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      props.row[item.name]
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "border-content-dialog",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    props.row[
                                                                      item.name
                                                                    ]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "border-nocontent-dialog",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    "No Data"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mini-dailog-title",
                                                staticStyle: {
                                                  "margin-top":
                                                    "20px !important",
                                                },
                                              },
                                              [
                                                _c("q-icon", {
                                                  attrs: {
                                                    name: "keyboard_arrow_right",
                                                    size: "xs",
                                                    color: "grey-8",
                                                  },
                                                }),
                                                _vm._v("유해위험요인 사진 "),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 q-mt-md fm",
                                              },
                                              [
                                                _c("c-upload-picture", {
                                                  attrs: {
                                                    height: "200px",
                                                    attachInfo:
                                                      _vm.getRiskHazardAttachInfo(
                                                        props.row
                                                          .ram4mAssessScenarioId
                                                      ),
                                                    editable: false,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }